// extracted by mini-css-extract-plugin
module.exports = {"title":"onlyhtml_title_2hKA6","callstyle":"onlyhtml_callstyle_7XkBw","navnav":"onlyhtml_navnav_1YHla","root":"onlyhtml_root_3eXFC","rootinner":"onlyhtml_rootinner_3_aXY"};